<template>
  <div id="ylContactWay">
    <ylContactWayMobile v-if="isMobileScreen" :list="list" />
    <ylContactWayPC v-else :list="list" />
  </div>
</template>
<script>
export default {
  name: "ylContactWay",
  components: {
    ylContactWayMobile: () => import("./components/mobile.vue"),
    ylContactWayPC: () => import("./components/pc.vue"),
  },
  data() {
    return {
      list: [],
    }
  },
  computed: {
    screenWidth() {
      return this.$store.getters.screenWidth;
    },
    screenHeight() {
      return this.$store.getters.screenHeight;
    },
    isMobileScreen() {
      return this.$store.getters.isMobileScreen;
    },
  },
  created() {
    this.contact()
  },
  methods: {
    async contact() {
      const res = await this.$api.contact()
      this.list = res
    }
  }
};
</script>